var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.top",value:(_vm.$t('DOCUMENT_WIZARD.PRINT_OPTION.PRINT_BTN_TOOLTIP')),expression:"$t('DOCUMENT_WIZARD.PRINT_OPTION.PRINT_BTN_TOOLTIP')",modifiers:{"top":true}}],staticClass:"btn btn--beta",class:[
        'btn',
        'btn--beta',
        { 'cf-c-btn-disabled': !_vm.canPrintDocument }
    ],attrs:{"type":"button","disabled":!_vm.canPrintDocument},on:{"click":_vm.printDocument}},[_c('app-icon',{attrs:{"size":"sm","icon":"print-icon"}}),_vm._v(" "+_vm._s(_vm.$t('DOCUMENT_WIZARD.PRINT_OPTION.PRINT_BTN_TEXT'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }